import type { LocationSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import type { FetchAllLocationsOptions } from '../location.api'
import { fetchAllLocations } from '../location.api'
import { locationsQueryKeys } from '../location.queryKeys'

export const useFetchAllLocations = (
  request: FetchAllLocationsOptions,
  queryOptions?: UseAppQueryOptions<LocationSchema[]>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: locationsQueryKeys.fetch.all(request?.queryParams),
    queryFn: () => fetchAllLocations(request)
    // Having initialData there means that the first time you go through this query, you return the initialData and store it in cache
    // It works fine in stale time = 0 because you will then fetch the query
    // but if staleTime is different from zero (which it is in the planning) it return [] and never refetch for 1 hour...
  })
}
